import { jsx as _jsx } from "react/jsx-runtime";
// Salvaged from ui-sprocket src/components/NameAvatar.tsx + avatarTone.ts — reviewed
// 2026-09-21: the six tone pairs moved into `tokens/color.ts`; the hash and initials helpers
// are unchanged; `noUncheckedIndexedAccess` guards added.
import Avatar from '@mui/material/Avatar';
import { alpha } from '@mui/material/styles';
import { AVATAR_TONES } from '../tokens/color.js';
import { rem } from '../tokens/type.js';
/** A small stable hash: the same name → the same tone index, in every session and tab. */
export function avatarToneIndex(name) {
    const key = name.trim().toLowerCase();
    let hash = 0;
    for (let i = 0; i < key.length; i += 1) {
        hash = (hash * 31 + key.charCodeAt(i)) | 0;
    }
    return Math.abs(hash) % AVATAR_TONES.length;
}
export function avatarToneFor(name) {
    return AVATAR_TONES[avatarToneIndex(name)] ?? AVATAR_TONES[0];
}
/** "Ben Carter" → "BC"; "ben.c@example.com" → "B"; "" → "?". */
export function initialsFor(name) {
    const words = name
        .trim()
        .split(/[\s._-]+/)
        .filter((w) => w && /[a-z0-9]/i.test(w));
    const first = words[0];
    const last = words[words.length - 1];
    if (!first)
        return '?';
    if (words.length === 1 || !last)
        return first.charAt(0).toUpperCase();
    return (first.charAt(0) + last.charAt(0)).toUpperCase();
}
/**
 * Initials in a tone chosen from the name, so a person looks the same in every list (§6).
 * Decorative by default (`aria-hidden`) because the name is always rendered beside it;
 * pass `label` when it stands alone (the account row's avatar button).
 */
export function NameAvatar({ name, size = 24, square = false, label, }) {
    const tone = avatarToneFor(name);
    const fontSize = size <= 22 ? rem(9) : size <= 28 ? rem(11) : size <= 32 ? rem(12) : rem(15);
    return (_jsx(Avatar, { ...(label ? { 'aria-label': label, role: 'img' } : { 'aria-hidden': true }), variant: square ? 'rounded' : 'circular', sx: (t) => ({
            width: size,
            height: size,
            fontSize,
            fontWeight: 600,
            flexShrink: 0,
            borderRadius: square ? `${Math.round(size / 4)}px` : '50%',
            bgcolor: t.palette.mode === 'light' ? tone.bg : alpha(tone.fgDark, 0.18),
            color: t.palette.mode === 'light' ? tone.fg : tone.fgDark,
        }), children: initialsFor(name) }));
}
//# sourceMappingURL=name-avatar.js.map